import 'moment/locale/ja';

const PNF = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

const moment = require("moment");

export default class Format {
    // カンマ区切り
    static comma_delimited(num, unit = '') {
        let buf = num;
        // if(!num)
        //     return '';
        if(num === null || num === undefined || num === ""){
            return ""
        }
        if(isNaN(num)) {
            buf = parseInt(num);
            if(isNaN(buf)) {
                return '';
            }
        }
        const options = { 
            style: 'decimal', 
            // currency: 'JPY' 
        }
        return new Intl.NumberFormat('ja-JP', options).format(buf) + unit
    }

    static phone_number(str) {
        return str&&str.replace(/-/g, '')
        // try {
        //     let tel = phoneUtil.format(phoneUtil.parse(str, 'JP'), PNF.NATIONAL);
        //     return tel;
        // } catch(e) {
        //     return '';
        // }
    }

    static zero_one_to_symbol(num) {
        let buf = num;
        if(num === undefined || num === '') {
            return '';
        }
        if(isNaN(num)) {
            buf = parseInt(num);
            if(isNaN(buf)) {
                return '';
            }
        }
        return buf === 0 ? '×' : buf === 1 ? '○' : '';
    }

    // 期間を返す 例:22/09/01（木）～ 22/09/30（木）
    static format_date_range_yymmdd(startData, endData) {
        return this.format_date_yymmdd(startData) + "〜" + this.format_date_yymmdd(endData)
    }

    // 日付を返す 例:22/09/30（木）
    static format_date_yymmdd(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        return buf.format("YY/MM/DD（ddd）");
    }

    static format_date(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        return buf.format("YY/MM/DD（ddd）");
    }
    static format_date_yyyymmdd(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        return buf.format("YYYY/MM/DD");
    }
    static format_date_en(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        let date = buf.format("MM/DD");
        return date;
    }
    static format_datetime(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        return buf.format("YY/MM/DD（ddd）HH:mm");
    }    
    static format_datetime_yymmdd(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        return buf.format("YY/MM/DD（ddd）HH:mm");
    }    
    static format_datetime_mmdd_hhmm(datestr) {
        if(!datestr)
            return '';
        moment.locale('ja');
        let buf = moment(datestr);
        if(!buf.isValid()) {
            return '-';
        }
        return buf.format("MM/DD HH:mm");
    }  

    static format_string(str,length){
        if(!str)
            return '';
        //console.log(length);
        // console.log(str.length);
        let result = "";
        if(str.length >= length){
            result = str.substring(0,length) + "...";
        }else{
            result = str;
        }
        return result;
        
    }
    static format_hankaku(str){
        return str.replace(/[Ａ-Ｚａ-ｚ０-９＠．]/g, function(s) {
            switch(s){
                case "ー":
                    return "-"
                default:
                    return String.fromCharCode(s.charCodeAt(0) - 65248);
            }
        });
    }
    static format_hankaku_lower(str){
        // console.log(str);
        if(str === undefined || str === '' || str === null) {
            return '';
        }
        return this.format_hankaku(str).toLowerCase();
    }

    static format_zip(str){
        return str.replace(/[０-９ー－―‐−]/g, function(s) {
            switch(s){
                case "ー":
                case "－":
                case "―":
                case "‐":
                case "−":
                    return "-"
                default:
                    return String.fromCharCode(s.charCodeAt(0) - 65248);
            }
        });
    }
    static format_number(str){
        const buf = parseInt(str);
        if(isNaN(buf)) {
            return null;
        }else{
            return buf
        }
    }
    static format_number_with_commas(str){
        const buf = parseInt(str);
        if(isNaN(buf)) {
            return "0";
        }else{
            return buf.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
    static dateToString(date, formatString){
        const year = date.getFullYear()
        const jpYear = this.toJpYear(year)
        const convertedDateString = formatString.replace('JJY', `${jpYear.name}${jpYear.num}`) // 令和2
            .replace('JJ', (jpYear.num>9?jpYear.num:"0"+jpYear.num)) // 02
            .replace('JY', `${jpYear.abbr}${jpYear.num}`) // R2
            .replace('J', jpYear.num) //2

            .replace('YYYY',year).replace('YY',date.getYear())
            .replace('MM', this.addZero(date.getMonth()+1)).replace('M', date.getMonth()+1)
            .replace('DD', this.addZero(date.getDate())).replace('D', date.getDate())
            .replace('hh', this.addZero(date.getHours()))
            .replace('mm', this.addZero(date.getMinutes()))
            .replace('ss', this.addZero(date.getSeconds()))
            
        return convertedDateString
    }
    static addZero(num) {
        return (num < 10)?("0" + num):num
    }
    static toJpYear(year){
        const yearNum = parseInt(year)
        if (yearNum >= 2019) {
            // 令和
            return {
                name: "令和",
                abbr: "R",
                num: yearNum - 2018
            }
        } else if (yearNum < 2019 && yearNum >= 1989) {
            // 平成
            return {
                name: "平成",
                abbr: "H",
                num: yearNum - 1988
            }
        } else if (yearNum < 1989 && yearNum >= 1926) {
            // 昭和
            return {
                name: "昭和",
                abbr: "S",
                num: yearNum - 1925
            }
        } else {
            return {
                name: "",
                num: yearNum
            }
        }
    }

    // 現場距離の時間表示用
    // 2026/01/09 #2494 対応
    // 1～30秒 → 0分30秒
    // 31～60秒 → 1分00秒
    static disp_time(site_distance_meter,request_type) {

        // 積替用地 + 10kmなら400mに
        // console.log(request_type,site_distance_meter)
        let math_minute = request_type == 3 && site_distance_meter > 9999 ? 400 : 80;
        // 分計算（1分80m換算）
        let distance_for_minute = Math.floor(site_distance_meter / math_minute);
        // 分以下を秒として計算（1分80m換算）
        let distance_for_sec = Math.ceil(site_distance_meter / math_minute * 60 % 60);
        // console.log(distance_for_minute,distance_for_sec,math_minute,site_distance_meter)
        // 31～60秒以上の場合、繰り上げ
        if(distance_for_sec >= 31){
            return String(distance_for_minute + 1) + "分";
        }
        // 1秒以上の場合（かつ30秒以内）30秒を追加
        else if(distance_for_sec >= 1){
           return distance_for_minute === 0 ? "30秒" : String(distance_for_minute) + "分30秒";
        // 0秒の場合、繰り下げ
        }else{
            return distance_for_minute + "分";
        }        
    }
}
